import React from 'react';
import { styled } from 'linaria/react';
import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import Header, { StyledBreadcrumbs } from '../ui/Header';
import get from 'lodash.get';
import AddProductsPage from '../Configurator/AddProductsPage';
import { DynamicPageContentRenderer } from '../ContentEditor/DynamicContentRenderer';
import { contentEditorComponents } from '../ContentEditor/ContentEditorComponents';
import MaxWidth from '../Layout/MaxWidth';
import { Helmet } from 'react-helmet-async';
import { theme } from '../Theme';
import { css } from 'linaria';

const Content = styled(MaxWidth)`
  margin-top: 2rem;

  img {
    width: 100%;
  }
`;

const NewsLetterWrap = styled('div')`
  max-width: 500px;
  margin: 1rem auto 3rem;
  .grecaptcha-badge {
    display: none;
  }
  .rulemailer-subscriber-form {
    font-family: 'Lato';
    width: 500px;
  }
  .rulemailer-subscriber-form input {
    display: block;
    width: 100%;
    margin: 5px 0 10px 0;
    border: 0px solid #f2f2f5 !important;
    background: #f2f2f5 !important;
    font-size: 14px;
    padding: 10px;
    outline: none !important;
    resize: none;
  }
  .rulemailer-subscriber-form input[type='checkbox'] {
    display: inline-block;
    width: auto;
    margin-right: 10px;
  }
  .rulemailer-subscriber-form button {
    display: block;
    margin-top: 20px;
    background: #911827;
    color: #fff;
    line-height: 1.33;
    font-size: 14px;
    padding: 8px 23px;
    height: 37px;
    cursor: pointer;
    border: 2px solid #911827;
    border-radius: 7px;
  }
  .rulemailer-subscriber-form button:hover {
    background: transparent;
    color: #911827;
  }
  .rulemailer-email-check {
    display: none !important;
  }
  span,
  a {
    font-size: 13px;
    color: black;
  }
`;

const pageBreadcrumbs = css`
  position: relative;
  li {
    color: ${theme.colors.black};
  }
`;

function ContentPage(props) {
  const { page, data } = props;

  const parents = get(data, 'route.parents');
  const breadcrumbProps = {
    breadcrumbText: page.breadcrumbText,
    parents,
  };

  return (
    <>
      {page?.id === '120' ? (
        <AddProductsPage />
      ) : (
        <>
          {page ? (
            // <h1>HEJ</h1>
            // <StyledBreadcrumbs {...breadcrumbProps} className={pageBreadcrumbs}/>
            <Header
              title={page.mainHeader || page.name}
              image={page.images}
              breadcrumbText={page.breadcrumbText}
              parents={get(data, 'route.parents')}
            />
          ) : // Show a dummy header if we don't have cached data
          null}

          <Content>
            {page ? (
              page.id == 70 ? (
                <NewsLetterWrap>
                  <Helmet>
                    <script
                      src="https://www.google.com/recaptcha/api.js"
                      async
                      defer
                    ></script>
                    <script
                      dangerouslySetInnerHTML={{
                        __html:
                          'function submitRuleOptin(token) {document.getElementById("rule-optin-form").submit();}',
                      }}
                    />
                  </Helmet>
                  <div class="rulemailer-subscriber-form">
                    <form
                      id="rule-optin-form"
                      action="https://app.rule.io/subscriber-form/subscriber"
                      method="POST"
                    >
                      <input type="hidden" value="105185" name="tags[]" />
                      <input
                        type="hidden"
                        name="token"
                        value="353b89b3-51ccbc5-2ec7b09-cc328b7-9d418d3-9db"
                      />
                      <label>E-post</label>
                      <input
                        type="email"
                        placeholder="E-post"
                        name="rule_email"
                        required="required"
                      />
                      <label>Förnamn</label>
                      <input
                        type="text"
                        placeholder="Förnamn"
                        name="fields[Möbelmästarna.Förnamn]"
                      />
                      <label>Efternamn</label>
                      <input
                        type="text"
                        placeholder="Efternamn"
                        name="fields[Möbelmästarna.Efternamn]"
                      />
                      <label>Mobilnummer</label>
                      <input
                        type="text"
                        placeholder="Mobilnummer"
                        name="fields[Möbelmästarna.Mobilnummer]"
                      />
                      <div>
                        <input type="checkbox" name="confirmation" required />
                        <span>
                          Genom att fylla i din e-postadress här samtycker du
                          till att ta emot marknadsföring och information via
                          e-post från Möbelmästarna Sverige AB.{' '}
                        </span>
                        <a
                          href="https://www.mobelmastarna.se/personpolicy-gdpr"
                          target="_blank"
                        >
                          Klicka här för att läsa mer om vår hantering av dina
                          personuppgifter
                        </a>
                      </div>
                      <label class="rulemailer-email-check">
                        Are you machine?
                      </label>
                      <input
                        type="checkbox"
                        name="email_field"
                        class="rulemailer-email-check"
                        value="1"
                        tabindex="-1"
                        autocomplete="off"
                      />
                      <input type="hidden" name="language" value="sv" />
                      <button
                        class="g-recaptcha"
                        data-sitekey="6LfbPnAUAAAAACqfb_YCtJi7RY0WkK-1T4b9cUO8"
                        data-callback="submitRuleOptin"
                      >
                        Skicka
                      </button>
                    </form>
                  </div>
                </NewsLetterWrap>
              ) : (
                <>
                  {/* <DynamicContent content={result.data.route.object.content} /> */}
                  <DynamicPageContentRenderer
                    pageId={page?.id}
                    rendererComponents={contentEditorComponents}
                  />
                </>
              )
            ) : (
              <LoadingLine
                heightPx={14}
                widthRem={30}
                randomizeWidthBy={10}
                count={10}
                style={{
                  marginBottom: '12px',
                }}
              />
            )}
          </Content>
        </>
      )}
    </>
  );
}

export default ContentPage;
